/* eslint-disable */
import React, { Profiler, ProfilerOnRenderCallback } from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import store from './redux/store';
import Views from './views';
import { THEME_CONFIG } from './configs/AppConfig';
import { env } from './configs/EnvironmentConfig';
import { ConfigProvider } from 'antd';
import useMediaQuery from './hooks/useMediaQuery';
import LockScreen from './components/shared-components/LockScreen';

// TODO: Deprecated in antd v5
// import 'antd/dist/antd.less';

function App() {
  const handleRender: ProfilerOnRenderCallback = (id, phase, actualDuration, baseDuration, startTime, commitTime) => {
    if (env?.ENV === 'dev') {
    }
  };

  const queryClient = new QueryClient();

  const { isMobile, isTablet } = useMediaQuery();

  return (
    <Profiler id="app-profiler" onRender={handleRender}>
      <div className="App">
        <Provider store={store}>
          <QueryClientProvider client={queryClient}>
            <LockScreen />
            <BrowserRouter>
              <ConfigProvider
                theme={{
                  token: { colorPrimary: THEME_CONFIG.primary },
                  components: {
                    Menu: {
                      popupBg: THEME_CONFIG.black,
                      colorBgContainer: isMobile || isTablet ? undefined : THEME_CONFIG.black,
                    },
                  },
                }}
              >
                <Views />
              </ConfigProvider>
            </BrowserRouter>
          </QueryClientProvider>
        </Provider>
      </div>
    </Profiler>
  );
}

export default App;
